// extracted by mini-css-extract-plugin
export default {"section":"features-section-module--section--3eX9+","features":"features-section-module--features--hKeAz","featureBox":"features-section-module--feature-box--gakEH"};